import React from 'react';
import { ampelMeta } from 'core/components/ui';

/**
 * Kompakte Urteils-Anzeige (farbiger Punkt + Score) fuer Tabellen.
 * Ohne Ampel/Score wird ein dezenter Strich angezeigt.
 */
export default function UrteilZelle({ ampel, score }) {
  if (!ampel || score == null) {
    return <span className="text-ink-muted">–</span>;
  }
  const m = ampelMeta(ampel);
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 font-mono text-xs font-semibold tabular-nums ring-1 ${m.chip}`}
      title={m.label}
    >
      <span className={`h-2 w-2 rounded-full ${m.dot}`} aria-hidden="true" />
      {score}
    </span>
  );
}
